export enum AssignmentToInterventionEnum {
    NotApplicable = 'NotApplicable',
    Randomized = 'Randomized',
    NonRandomized = 'NonRandomized',
}
